<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="col-lg-3">
                    <rules-nav-app @index="init" class="mb-32"></rules-nav-app>

                    <div class="d-none d-xl-block">
                        <catalog-categories></catalog-categories>
                    </div>
                </div>

                <div class="col-lg-9">
                    <div v-if="rule">
                        <div class="box-shadow mb-40">
                            <div class="mb-24" v-if="rule.big_image">
                                <img :src="'/storage/' + rule.big_image" :alt="rule.title" class="img-fluid">
                            </div>
                            <div v-html="rule.long_desc"></div>
                        </div>
                        <div v-if="rulesLatest && rulesLatest.length > 0">
                            <span class="title-2 mb-28">Вас также может заинтересовать:</span>
                            <div class="grid-container" v-if="rulesLatest">
                                <div class="box-grid" v-for="(item, i) in rulesLatest"
                                     :key="i">
                                    <router-link :to="'/rules/' + item.slug">
                                        <img :src="'/storage/' + item.image" :alt="item.title">
                                        <!--                                        <img src="/storage/vSHpsbRTzuWCkN9zL6XIUkHHKtm4nQgaJSoQdnhw.jpeg" :alt="item.title">-->
                                        <span class="title-4 color-text-white">{{item.title}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>

                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                loading: true,
                rule: null,
                rulesLatest: null,

                breadcrumb: null,
                seo_text: null
            }
        },

        // mounted() {
        //     this.init()
        // },

        methods: {
            init(e, seo_text) {
                let url = '/api/rules/show';
                this.seo_text = seo_text
                axios.post(url, {'slug': e})
                    .then(response => {
                       this.rule = response.data.rule;
                       this.rulesLatest = response.data.rulesLatest;
                       this.getBreadcrumb();
                       this.loading = false;

                    })

            },
            getBreadcrumb() {
                this.breadcrumb = [
                    {
                        text: 'Главная',
                        to: { name: 'pages-index' }
                    },
                    {
                        text: this.rule.title,
                        active: true
                    }
                ]
            }
        }
    }

</script>

